import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Customers from "./pages/Customers";
import Suppliers from "./pages/Suppliers";
import Sales from "./pages/Sales";
import Purchases from "./pages/Purchases";
import ServicePurchases from "./pages/ServicePurchases";
import Collections from "./pages/Collections";
import Payments from "./pages/Payments";
import Offsets from "./pages/Offsets";
import Expenses from "./pages/Expenses";
import CashAccounts from "./pages/CashAccounts";
import BankAccounts from "./pages/BankAccounts";
import CreditCards from "./pages/CreditCards";
import Agenda from "./pages/Agenda";
import Reports from "./pages/Reports";
import Backup from "./pages/Backup";
import Users from "./pages/Users";
import CreditNotes from "./pages/CreditNotes";
import DebitNotes from "./pages/DebitNotes";

// Initialize axios interceptors
import "./utils/axiosConfig";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="customers" element={<Customers />} />
            <Route path="suppliers" element={<Suppliers />} />
            <Route path="sales" element={<Sales />} />
            <Route path="purchases" element={<Purchases />} />
            <Route path="service-purchases" element={<ServicePurchases />} />
            <Route path="credit-notes" element={<CreditNotes />} />
            <Route path="debit-notes" element={<DebitNotes />} />
            <Route path="collections" element={<Collections />} />
            <Route path="payments" element={<Payments />} />
            <Route path="offsets" element={<Offsets />} />
            <Route path="expenses" element={<Expenses />} />
            <Route path="cash-accounts" element={<CashAccounts />} />
            <Route path="bank-accounts" element={<BankAccounts />} />
            <Route path="credit-cards" element={<CreditCards />} />
            <Route path="agenda" element={<Agenda />} />
            <Route path="reports" element={<Reports />} />
            <Route path="backup" element={<Backup />} />
            <Route path="users" element={<Users />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
